module.exports = {
	"1": "KGS",
	"2": "RUR",
	"4": "KZT",
	"5": "USD",
	"6": "EUR",
	"15": "UZS"
};


//////////////////
// WEBPACK FOOTER
// ./js/shared/dictionaries/accountResources.json
// module id = 1815
// module chunks = 2